import CategoryToggleTab from "@/components/CategoryToggleTab";
import { SYSTEMS_CATEGORIES } from "@/lib/systemsTemplates";
import { getGoal } from "@/lib/projectGoals";

export default function SystemsTab({ project, onChange, costLibrary = null }) {
  const goal = getGoal(project?.project_goal);
  return (
    <CategoryToggleTab
      project={project}
      onChange={onChange}
      field="systems"
      categories={SYSTEMS_CATEGORIES}
      title={goal.systems.heading}
      description="Whole-property systems — electrical, plumbing, heating, solar, global finishes. Independent of rooms and exterior."
      note={goal.systems.note}
      totalTestId="systems-grand-total"
      cardTestPrefix="sys"
      rateOverrides={costLibrary?.systems_rates || null}
      currency={project?.currency || "USD"}
    />
  );
}
